import { BarItem, DrillDownData, GpsDevicePoint, LineData, PieData } from '../Types';

const barData = {
  topLevel: [
    { category: 'Head Protection', value: 180 },
    { category: 'Hand Protection', value: 250 },
    { category: 'Foot Protection', value: 130 },
    { category: 'Fall Protection', value: 90 },
    { category: 'Tools', value: 200 },
  ] as BarItem[],
  drillDown: {
    'Head Protection': [
      { subcategory: 'Hard Hats', value: 100 },
      { subcategory: 'Safety Visors', value: 50 },
      { subcategory: 'Ear Muffs', value: 30 },
    ],
    'Hand Protection': [
      { subcategory: 'Work Gloves', value: 150 },
      { subcategory: 'Cut-Resistant Gloves', value: 70 },
      { subcategory: 'Chemical Gloves', value: 30 },
    ],
    'Foot Protection': [
      { subcategory: 'Steel-Toe Boots', value: 80 },
      { subcategory: 'Slip-Resistant Shoes', value: 50 },
    ],
    'Fall Protection': [
      { subcategory: 'Safety Harnesses', value: 60 },
      { subcategory: 'Lanyards', value: 30 },
    ],
    Tools: [
      { subcategory: 'Power Drills', value: 90 },
      { subcategory: 'Cement Mixers', value: 70 },
      { subcategory: 'Measuring Tapes', value: 40 },
    ],
  } as DrillDownData,
};

// Mock data for the line chart
const lineData: LineData[] = [
  {
    id: 'Total Spend',
    data: [
      { x: 'Jan', y: 45000 },
      { x: 'Feb', y: 52000 },
      { x: 'Mar', y: 48000 },
      { x: 'Apr', y: 61000 },
      { x: 'May', y: 55000 },
    ],
  },
];

// Mock data for the pie chart
const pieData: PieData[] = [
  { id: 'Head Protection', label: 'Head Protection', value: 25, color: '#0098aa' },
  { id: 'Hand Protection', label: 'Hand Protection', value: 30, color: '#f19135' },
  { id: 'Foot Protection', label: 'Foot Protection', value: 20, color: '#666666' },
  { id: 'Fall Protection', label: 'Fall Protection', value: 15, color: '#ff3333' },
  { id: 'Tools', label: 'Tools', value: 10, color: '#ff9900' },
];

// Combine all mock data into a single export
export const mockData = {
  barData,
  lineData,
  pieData,
};


  const deviceData: GpsDevicePoint[] = [
  {
    id: 2001,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.78",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-01T08:00:00.000Z",
    latitude: "32.776664",
    longitude: "-96.796988",
    altitude: null,
    speed_over_ground: 0.0,
    course_over_ground: 0,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.2,
    vdop: 1.0,
    satellites_in_view: 7,
    cn0_max: 35.2,
    hpa: "1013.2",
    recorded_at: "2025-07-01T08:00:06.000Z"
  },
  {
    id: 2002,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.79",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-01T14:30:00.000Z",
    latitude: "32.789722",
    longitude: "-96.808333",
    altitude: null,
    speed_over_ground: 25.4,
    course_over_ground: 45,
    fix_mode: 3,
    hdop: 0.7,
    pdop: 1.1,
    vdop: 0.9,
    satellites_in_view: 8,
    cn0_max: 36.8,
    hpa: "1012.8",
    recorded_at: "2025-07-01T14:30:06.000Z"
  },
  {
    id: 2003,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.80",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-01T19:45:00.000Z",
    latitude: "32.812500",
    longitude: "-96.798611",
    altitude: null,
    speed_over_ground: 18.7,
    course_over_ground: 120,
    fix_mode: 3,
    hdop: 0.9,
    pdop: 1.3,
    vdop: 1.1,
    satellites_in_view: 6,
    cn0_max: 34.9,
    hpa: "1012.5",
    recorded_at: "2025-07-01T19:45:06.000Z"
  },
  // July 2, 2025 - Moving to North Dallas
  {
    id: 2004,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.81",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-02T09:15:00.000Z",
    latitude: "32.915278",
    longitude: "-96.835833",
    altitude: null,
    speed_over_ground: 32.1,
    course_over_ground: 350,
    fix_mode: 3,
    hdop: 0.6,
    pdop: 1.0,
    vdop: 0.8,
    satellites_in_view: 9,
    cn0_max: 37.2,
    hpa: "1011.9",
    recorded_at: "2025-07-02T09:15:06.000Z"
  },
  {
    id: 2005,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.82",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-02T12:00:00.000Z",
    latitude: "32.963889",
    longitude: "-96.869444",
    altitude: null,
    speed_over_ground: 0.0,
    course_over_ground: 0,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.2,
    vdop: 1.0,
    satellites_in_view: 7,
    cn0_max: 35.7,
    hpa: "1011.3",
    recorded_at: "2025-07-02T12:00:06.000Z"
  },
  {
    id: 2006,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.83",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-02T16:30:00.000Z",
    latitude: "32.978611",
    longitude: "-96.880556",
    altitude: null,
    speed_over_ground: 15.3,
    course_over_ground: 270,
    fix_mode: 3,
    hdop: 0.7,
    pdop: 1.1,
    vdop: 0.9,
    satellites_in_view: 8,
    cn0_max: 36.1,
    hpa: "1010.8",
    recorded_at: "2025-07-02T16:30:06.000Z"
  },
  // July 3, 2025 - Trip to Arlington/Fort Worth area
  {
    id: 2007,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.84",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-03T10:45:00.000Z",
    latitude: "32.735278",
    longitude: "-97.108056",
    altitude: null,
    speed_over_ground: 45.6,
    course_over_ground: 225,
    fix_mode: 3,
    hdop: 0.9,
    pdop: 1.4,
    vdop: 1.2,
    satellites_in_view: 6,
    cn0_max: 34.3,
    hpa: "1009.5",
    recorded_at: "2025-07-03T10:45:06.000Z"
  },
  {
    id: 2008,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.85",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-03T14:20:00.000Z",
    latitude: "32.701389",
    longitude: "-97.120833",
    altitude: null,
    speed_over_ground: 22.8,
    course_over_ground: 180,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.3,
    vdop: 1.1,
    satellites_in_view: 7,
    cn0_max: 35.4,
    hpa: "1008.9",
    recorded_at: "2025-07-03T14:20:06.000Z"
  },
  {
    id: 2009,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.86",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-03T18:10:00.000Z",
    latitude: "32.683333",
    longitude: "-97.142222",
    altitude: null,
    speed_over_ground: 8.4,
    course_over_ground: 90,
    fix_mode: 3,
    hdop: 1.0,
    pdop: 1.5,
    vdop: 1.3,
    satellites_in_view: 5,
    cn0_max: 33.8,
    hpa: "1008.2",
    recorded_at: "2025-07-03T18:10:06.000Z"
  },
  // July 4, 2025 - Holiday, staying local in East Dallas
  {
    id: 2010,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.87",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-04T11:30:00.000Z",
    latitude: "32.803056",
    longitude: "-96.749444",
    altitude: null,
    speed_over_ground: 12.1,
    course_over_ground: 65,
    fix_mode: 3,
    hdop: 0.7,
    pdop: 1.2,
    vdop: 1.0,
    satellites_in_view: 8,
    cn0_max: 36.7,
    hpa: "1007.8",
    recorded_at: "2025-07-04T11:30:06.000Z"
  },
  {
    id: 2011,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.88",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-04T15:45:00.000Z",
    latitude: "32.823611",
    longitude: "-96.728889",
    altitude: null,
    speed_over_ground: 6.7,
    course_over_ground: 135,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.3,
    vdop: 1.1,
    satellites_in_view: 7,
    cn0_max: 35.1,
    hpa: "1007.3",
    recorded_at: "2025-07-04T15:45:06.000Z"
  },
  {
    id: 2012,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.89",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-04T20:15:00.000Z",
    latitude: "32.813889",
    longitude: "-96.738056",
    altitude: null,
    speed_over_ground: 0.0,
    course_over_ground: 0,
    fix_mode: 3,
    hdop: 0.9,
    pdop: 1.4,
    vdop: 1.2,
    satellites_in_view: 6,
    cn0_max: 34.6,
    hpa: "1006.9",
    recorded_at: "2025-07-04T20:15:06.000Z"
  },
  // July 5, 2025 - Weekend trip to Plano/Richardson
  {
    id: 2013,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.90",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-05T09:00:00.000Z",
    latitude: "33.019722",
    longitude: "-96.696944",
    altitude: null,
    speed_over_ground: 38.2,
    course_over_ground: 15,
    fix_mode: 3,
    hdop: 0.6,
    pdop: 1.0,
    vdop: 0.8,
    satellites_in_view: 9,
    cn0_max: 37.5,
    hpa: "1006.4",
    recorded_at: "2025-07-05T09:00:06.000Z"
  },
  {
    id: 2014,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.91",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-05T13:25:00.000Z",
    latitude: "33.086111",
    longitude: "-96.675278",
    altitude: null,
    speed_over_ground: 19.4,
    course_over_ground: 295,
    fix_mode: 3,
    hdop: 0.7,
    pdop: 1.1,
    vdop: 0.9,
    satellites_in_view: 8,
    cn0_max: 36.3,
    hpa: "1005.8",
    recorded_at: "2025-07-05T13:25:06.000Z"
  },
  {
    id: 2015,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.92",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-05T17:50:00.000Z",
    latitude: "33.051389",
    longitude: "-96.707500",
    altitude: null,
    speed_over_ground: 14.6,
    course_over_ground: 200,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.2,
    vdop: 1.0,
    satellites_in_view: 7,
    cn0_max: 35.9,
    hpa: "1005.2",
    recorded_at: "2025-07-05T17:50:06.000Z"
  },
  // July 6, 2025 - Sunday, South Dallas/Oak Cliff area
  {
    id: 2016,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.93",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-06T10:15:00.000Z",
    latitude: "32.742500",
    longitude: "-96.813056",
    altitude: null,
    speed_over_ground: 28.9,
    course_over_ground: 185,
    fix_mode: 3,
    hdop: 0.9,
    pdop: 1.3,
    vdop: 1.1,
    satellites_in_view: 6,
    cn0_max: 34.7,
    hpa: "1004.7",
    recorded_at: "2025-07-06T10:15:06.000Z"
  },
  {
    id: 2017,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.94",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-06T14:40:00.000Z",
    latitude: "32.706944",
    longitude: "-96.835278",
    altitude: null,
    speed_over_ground: 11.3,
    course_over_ground: 320,
    fix_mode: 3,
    hdop: 1.0,
    pdop: 1.4,
    vdop: 1.2,
    satellites_in_view: 5,
    cn0_max: 33.2,
    hpa: "1004.1",
    recorded_at: "2025-07-06T14:40:06.000Z"
  },
  {
    id: 2018,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.95",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-06T18:20:00.000Z",
    latitude: "32.725833",
    longitude: "-96.821111",
    altitude: null,
    speed_over_ground: 7.8,
    course_over_ground: 75,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.3,
    vdop: 1.1,
    satellites_in_view: 7,
    cn0_max: 35.6,
    hpa: "1003.5",
    recorded_at: "2025-07-06T18:20:06.000Z"
  },
  // July 7, 2025 - Back to original area, end of tracking period
  {
    id: 2019,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.96",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-07T08:30:00.000Z",
    latitude: "32.771944",
    longitude: "-96.789167",
    altitude: null,
    speed_over_ground: 24.1,
    course_over_ground: 60,
    fix_mode: 3,
    hdop: 0.7,
    pdop: 1.1,
    vdop: 0.9,
    satellites_in_view: 8,
    cn0_max: 36.4,
    hpa: "1002.8",
    recorded_at: "2025-07-07T08:30:06.000Z"
  },
  {
    id: 2020,
    device_id: "866349048085405",
    name: "BMRAE22245019279928",
    voltage: "3.97",
    gnss_run_status: 4,
    fix_status: 1,
    utc_datetime: "2025-07-07T16:45:00.000Z",
    latitude: "32.779100",
    longitude: "-96.637400",
    altitude: null,
    speed_over_ground: 5.2,
    course_over_ground: 140,
    fix_mode: 3,
    hdop: 0.8,
    pdop: 1.2,
    vdop: 1.0,
    satellites_in_view: 7,
    cn0_max: 35.8,
    hpa: "1002.3",
    recorded_at: "2025-07-07T16:45:06.000Z"
  }
];